<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="供应商名称">
                            <c-input name="supplier_name"></c-input>
                        </m-search-item>
                        <m-search-item label="联系人姓名">
                            <c-input name="contact_name"></c-input>
                        </m-search-item>
                        <m-search-item label="联系电话">
                            <c-input name="contact_phone"></c-input>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button color="main" v-if="auth('b_purchase_supplier_edit')"
                              prepend-icon="tf-add"
                              @click="$refs.purchaseSupplierEdit.open()">创建供应商
                    </c-button>
                    <c-button v-if="auth('b_purchase_supplier_export')"
                              prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_purchase_supplier_edit')"
                              prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveSupplier">删除
                    </c-button>
                </template>

                <!--启禁用状态-->
                <template #state="{data}">
                    <c-switch v-if="auth('b_purchase_supplier_edit') " v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                    <c-state v-else tag dict="disableEnableDic" :value="data.state"></c-state>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="110"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_purchase_supplier_edit')" icon="tf-edit" @click="$refs.purchaseSupplierEdit.open(data)">编辑
                        </c-table-button>
                        <c-table-button v-if="auth('b_purchase_supplier_edit')" icon="tf-trash" color="red" @click="removeSupplier(data)">删除
                        </c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--新增、编辑采购供应商弹窗-->
            <purchase-supplier-edit ref="purchaseSupplierEdit" @resolve="$refs.view.update()"></purchase-supplier-edit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import purchaseSupplierEdit from "@/pages/purchase/purchase_supplier_edit.vue";

export default {
    components: {
        purchaseSupplierEdit
    },

    data() {
        return {
            //默认筛选项
            defaultSearchData: {
                user_type:1   //商家主账号
            },
            workType: 16
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo', 'disableEnableDic'])
    },

    methods: {
        /******供应商启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/purchase/supplier/edit/state',
                data: {
                    id: data.id,
                    state: state ? 2 : 1
                },
                success: (data, message) => {
                    this.$message({
                        message: message,  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        },

        /****批量删除供应商***/
        batchRemoveSupplier() {
            var ids = [];
            this.$refs.view.$refs.list.getData('selected').forEach(item => {
                ids.push(item.id);
            });

            this.$confirm({
                message: '确认删除' + ids.length + '条供应商记录吗？删除后不可恢复',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/supplier/remove/batch',
                        data: {ids: ids},
                        loading: true,
                        success: data => {
                            let Mtype = 'success';
                            let message = '成功' + data.success_count + '条';
                            if (data.fail_count > 0 && data.success_count > 0) {
                                Mtype = 'warn';
                                message += '，失败' + data.fail_count + '条';
                            } else if (data.fail_count > 0 && data.success_count == 0) {
                                Mtype = 'fail'
                                message += '，失败' + data.fail_count + '条';
                            } else {
                                message = '成功删除' + data.success_count + '条记录';
                            }
                            this.$message({
                                message: message,  // 提示内容,
                                type: Mtype
                            });
                            //刷新
                            this.$refs.view.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        /******删除供应商************/
        removeSupplier(data) {
            this.$confirm({
                message: '确认删除供应商【' + data.supplier_name + '】？删除后不可恢复',  // 提示内容,
                // buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/purchase/supplier/remove',
                        data: {id: data.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',  // 提示内容,
                            });
                            //刷新
                            this.$refs.view.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>